import React from "react";
import TranslationModule from "~/common/TranslationModule";
import { Autorenew as Icon } from "@material-ui/icons";

class ErrorBoundary extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    renderLoadingIcon() {
        if (this.props.fallback !== undefined)
            return this.props.fallback;
        else
            return fallback();
    }

    renderErrorMessage(error) {
        let rootError = error || "OTM_UNKNOWN_ERROR";

        while (rootError.error)
            rootError = rootError.error;

        if (rootError.message)
            rootError = rootError.message;

        return TranslationModule.translate(rootError.toString());
    }

    render() {
        if (this.state.errorInfo)
            return (
                <header className="w-100 border">
                    <h2 className="text-center ms-1 ms-sm-2 text-danger" data-testid="error-boundary">
                        {this.renderErrorMessage(this.state.error)}
                    </h2>
                </header>
            );
        else
            return (
                <React.Suspense fallback={this.renderLoadingIcon()}>
                    {this.props.children}
                </React.Suspense>
            );
    }
}

export default ErrorBoundary;

export const FallbackIcon = ({ className, children }) => {
    return (
        <Icon className={`spinner loading-icon-color ${className}`}>
            {children}
        </Icon>
    );
};

export const fallback = () => {
    return (
        <div className="d-flex justify-content-center">
            <Icon className="loading-icon loading-icon-color" />
        </div>
    );
};